module.exports = __webpack_public_path__ + "img/avatar-default.9bdc2a53.svg";